/* eslint no-unused-vars: ["error", { "argsIgnorePattern": "^_" }] */
"use client";
import React, {useEffect, useState} from "react";

const SCROLLBACK_THRESHOLD = 40;

const scrollBack = () =>
  window.scroll({
    top: 0,
    behavior: "smooth",
  });

const ScrollBackButton = () => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = _event => {
      setScrollTop(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  let displayMode = "none";
  if (scrollTop && scrollTop > SCROLLBACK_THRESHOLD) {
    displayMode = "block";
  }

  return (
    <a className="button is-dark is-scrollback"
       id="scrollback"
       style={{display: displayMode}}
       title="Go to top"
       onClick={scrollBack}
    >
      &uarr;
    </a>
  );
};

export default ScrollBackButton;
